<template>
    <div class="panel-body">
      <div class="left">
        <div class="mr-t-10">
          <p class="discription text-size-20">STOCKCREW倉庫商品の受取金額差額を設定できます</p>
          <p class="discription">「Amazon倉庫の受取金額」に対する差額をご設定ください。</p>
          <p class="discription">すでに出品登録済み商品の受取金額には影響しません。</p>
          <form data-vv-scope="setting-form" class="mr-t-20">
            <fieldset class="border bg-light-soft flex flex-flow-column gap-10 pd-t-10">
              <div class="">Amazon倉庫の受取金額からの減額費用をご入力ください</div>
              <label class="control-label flex-lable label-width-3 pd-t-5 pd-b-5 pd-l-10">受取金額差額
                <span class="text-danger m-r-sm">＊</span>
              </label>
              <div class="flex flex-content-center label-width-3 gap-10">
                <input-money
                  v-model="offerPriceScDiff"
                  validation="required|moneyMin:0|numberLength:6"
                  label="受取金額差額"
                  :allowNegative="false"
                  @input="handleInputOfferPriceScDiff"
                  class="custom-border"
                ></input-money>円
              </div>
            </fieldset>
            <br>
            <fieldset class="border bg-light-soft flex flex-flow-column gap-10 ">
              <div class="">
                <p>受取金額のシミュレーション</p>
                <div class="flex flex-content-center gap-15" style="justify-content: flex-start;">
                  <span>Amazon倉庫の受取金額が</span>
                  <div class="flex flex-content-center gap-10">
                    <input-money
                        v-model="amazonAmountReceived"
                        validation="required|moneyMin:1|numberLength:6"
                        label="Amazon倉庫の受取金額が"
                        :allowNegative="false"
                        @input="handlerInputAmazonAmountReceived"
                        class="custom-border"
                      ></input-money>
                    <span class="label-width-3">円 の場合</span>
                  </div>
                </div>
                <div class="flex flex-content-center gap-15 mr-t-15" style="justify-content: left;">
                  <div class="w-200">
                    <br>
                    <div class="text-right bg-primary pd-t-5 pd-b-5 pd-r-10">
                      受取金額(税込) <br>
                      予想出品金額(税込)
                    </div>
                    <div class="text-right bg-white pd-t-10 pd-b-10 pd-l-10 pd-r-10">
                      <div class="flex flex-content-center" style="justify-content: space-between;">
                        <img :src="amazonIconUrl" alt="#" class="w-30">
                        ¥
                        <input
                          :value="formatAmount(amazonAmountReceived)"
                          type="text"
                          class="form-control text-right bd-rds-8 w-120"
                          disabled />
                      </div>
                      <span class="text-price text-price-number">¥{{ expectedAmount(amazonAmountReceived) }}</span>
                    </div>
                  </div>
                  <i class="fa fa-caret-right text-red text-size-45" aria-hidden="true"></i>
                  <div class="">
                    <span class="text-danger text-right">STOCKCREW倉庫の受取金額をご確認ください</span>
                    <div class="text-right bg-primary pd-t-5 pd-b-5 pd-r-10 w-200">
                      受取金額(税込) <br>
                      予想出品金額(税込)
                    </div>
                    <div class="text-right w-200 bg-white pd-t-10 pd-b-10 pd-l-10 pd-r-10">
                      <div class="flex flex-content-center" style="justify-content: space-between;">
                        <img :src="salmonIconUrl" alt="#" class="w-30">
                        ¥
                        <input
                          :value="formatAmount(salmonAmountReceived)"
                          type="text"
                          class="form-control text-right bd-rds-8 w-120"
                          disabled />
                      </div>
                      <span class="text-price text-price-number">¥{{ expectedAmount(salmonAmountReceived) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            <div class="mr-t-20">
              <button type="button" class="btn btn-warning w-120 check-maintenance" @click.prevent="updateSetting()" :disabled="disabled">
                更新
                <i class="fa fa-check text-size-16" aria-hidden="true"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>

<script>
import Util from '@/common/utility'
import Const from '@/common/msg'
import SettingService from '@/services/settingservice'
import InputMoney from '@/components/InputMoney'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      disabled: true,
      err: null,
      loader: null,
      oldOfferPriceScDiff: null,
      amazonAmountReceived: 1800,
      offerPriceScDiff: 200
    }
  },
  components: {
    InputMoney
  },
  created () {
    this.oldOfferPriceScDiff = this.$store.getters.getUser.offerPriceScDiff
    this.offerPriceScDiff = this.$store.getters.getUser.offerPriceScDiff || this.$store.getters.getUser.offerPriceScDiffSetting
  },
  mounted () {
    this.checkDisabledButton()
    let logParams = {
      name: eventCode.warehouse_sc.setting_tab.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  },
  methods: {
    async updateSetting () {
      if (this.offerPriceScDiff !== null) {
        let logParams = {}
        logParams = {
          name: eventCode.warehouse_sc.setting_tab.click_update_btn,
          properties: {
            oldOfferPriceScDiff: this.oldOfferPriceScDiff,
            newOfferPriceScDiff: this.offerPriceScDiff
          }
        }
        EventService.postTrackLog(logParams)

        this.loader = this.$loading.show()
        const payload = {
          record: {
            offerPriceScDiff: this.offerPriceScDiff
          }
        }
        SettingService.updateSetting(payload)
          .then((response) => {
            this.$store.commit('toggleModal', {
              show: true,
              message: Const.updateSuccess
            })
            this.oldOfferPriceScDiff = payload.record.offerPriceScDiff
          })
          .catch((error) => {
            this.$events.fire('handleError', error)
            this.err = error
          })
          .finally(() => {
            this.loader && this.loader.hide()
          })
      }
    },
    async checkDisabledButton () {
      this.disabled = this.offerPriceScDiff === null
    },
    expectedAmount (offerPrice) {
      const coefficient = 1.3
      const tmpOfferPrice = Math.round(offerPrice)
      if (offerPrice !== null && offerPrice > 0 && tmpOfferPrice.toString().length <= 6) {
        return this.formatAmount(offerPrice * coefficient)
      }
      return ' -'
    },
    formatAmount (value) {
      return (value === null || typeof value === 'undefined' || value <= 0) ? '-' : `${Util.formatMoney(value)}`
    },
    handleInputOfferPriceScDiff (data) {
      this.offerPriceScDiff = data.newMoney
    },
    handlerInputAmazonAmountReceived (data) {
      this.amazonAmountReceived = data.newMoney
    }
  },
  computed: {
    salmonAmountReceived () {
      return this.amazonAmountReceived - this.offerPriceScDiff
    },
    amazonIconUrl () {
      return this.$store.getters.getWareHouseIcons['Amazon']
    },
    salmonIconUrl () {
      return this.$store.getters.getWareHouseIcons['salmonSc']
    }
  },
  watch: {
    offerPriceScDiff: {
      handler () {
        this.checkDisabledButton()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.fa-caret-right:before {
  content: "\f0da\f0da\f0da";
}
.discription {
  margin-bottom: 0;
}
fieldset.border {
  padding: 10px;
}
.custom-border {
  border: 1px solid #ffc000 !important;
  border-radius: 4px;
}
.text-price {
  color: #B12704;
}
.text-price-number {
  font-size: 20px;
  font-weight: bold;
}
.bg-primary {
  background-color: #008cc6;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/SettingAcrossPriceDiff.vue